// extracted by mini-css-extract-plugin
export var label = "_dd-2";
export var slideContainer = "_dd-0";
export var slider = "_dd-1";